<div class="toby sidebar-panel">
    <div id="scroll-area" class="space navigation-hold" fxLayout="column">
        <div class="dana sidebar-hold" [style.width]="isCompact ? '64px' : '15rem'">
            <!-- App Logo -->
            <div class="branding">
                <img [src]="'images/ihm-app-logo-small.png' | environment" alt="" class="app-logo">
                <p class="app-logo-text" *ngIf="!isCompact">Varuna <br><span>Sentinels</span> </p>
                <span style="margin: auto" *ngIf="!isCompact"></span>
                <!-- Toggle: hamburger icon in compact, pill switch in full -->
                <button *ngIf="isCompact" mat-icon-button class="compact-toggle-btn"
                        (click)="toggleCollapse()" matTooltip="Expand sidebar" matTooltipPosition="right">
                    <mat-icon>menu</mat-icon>
                </button>
                <div *ngIf="!isCompact" class="sidebar-compact-switch active"
                     [ngClass]="{remove:layoutConf.sidebarCompactToggle}"
                     (click)="toggleCollapse()"><span></span>
                </div>
            </div>
            <header class="app-user MuiPaper-root-299 MuiAppBar-root-288 jss360 MuiAppBar-positionStatic-292 flex-col items-center justify-center pt-24 pb-64 MuiPaper-elevation0-302">
                <p *ngIf="!isCompact" class="app-user-name MuiTypography-root-329 username text-16 whitespace-no-wrap MuiTypography-body1-331 MuiTypography-colorInherit-351">Hi {{user.name}},</p>
                <p *ngIf="!isCompact" class="app-user-name MuiTypography-root-329 email text-13 mt-8 whitespace-no-wrap MuiTypography-body1-331 MuiTypography-colorInherit-351">{{user.email}}</p>
                <div class="MuiAvatar-root-362 MuiAvatar-circle-364 jss361 avatar app-user-photo">
                    <img *ngIf="!currentPhotoSrc" alt="user photo" [src]="'images/user1.jpg' | environment" class="MuiAvatar-img-367 jss14">
                    <img *ngIf="currentPhotoSrc" alt="user photo" [src]="currentPhotoSrc" class="MuiAvatar-img-367 jss14">
                </div>
                <button *ngIf="!isCompact" type="button" class="camera-float" (click)="openUploadPopup($event)" aria-label="Change profile picture">
                    <mat-icon>photo_camera</mat-icon>
                </button>
            </header>

            <!-- Navigation -->
            <app-sidenav class="" [items]="menuItems" [hasIconMenu]="hasIconTypeMenuItem" [iconMenuTitle]="iconTypeMenuTitle" [isCompact]="isCompact"
                         (expandSidebar)="toggleCollapse()">
            </app-sidenav>
        </div>

    </div>
    <div class="button-container app-user-controls tt-color" [style.width]="isCompact ? '64px' : '15rem'">
        <button class="text-muted w-100" mat-icon-button mat-xs-button (click)="logOut()"
                [matTooltip]="isCompact ? 'Sign out' : ''" matTooltipPosition="right">
             <mat-icon *ngIf="isCompact">exit_to_app</mat-icon>
             <span class="signout-text" *ngIf="!isCompact">Sign out</span>
         </button>
     </div>
</div>

<!-- Upload Photo Popup -->
<div class="pp-backdrop" *ngIf="showUploadPopup" (click)="closeAllPopups()"></div>
<div class="pp-modal" *ngIf="showUploadPopup" (click)="$event.stopPropagation()">
  <div class="pp-header--teal">
    <div class="pp-head-left">
      <div class="pp-head-icon"><mat-icon>photo_camera</mat-icon></div>
      <div>
        <div class="pp-title">Upload Profile Picture</div>
        <div class="pp-subtitle">Choose a photo for your company</div>
      </div>
    </div>
    <button class="pp-close" (click)="closeAllPopups()" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>
  <div class="pp-body">
    <div class="pp-current">
      <div class="pp-current-card">
        <div class="pp-avatar">
          <ng-container *ngIf="uploadedImageSrc || currentPhotoSrc; else noPhoto">
            <img [src]="uploadedImageSrc || currentPhotoSrc" alt="Current photo">
          </ng-container>
          <ng-template #noPhoto>
            <mat-icon>account_circle</mat-icon>
          </ng-template>
        </div>
        <div class="pp-current-text">
          <div class="pp-current-title">Current Photo</div>
          <div class="pp-current-note">{{ (uploadedImageSrc || currentPhotoSrc) ? 'Preview selected image' : 'No photo uploaded yet' }}</div>
        </div>
      </div>
    </div>
    <div class="pp-uploader" (click)="fileInput.click(); $event.stopPropagation()" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
      <div class="pp-upload-circle"><mat-icon>file_upload</mat-icon></div>
      <div class="pp-upload-text">Drag and drop your image</div>
      <div class="pp-upload-or">or</div>
      <button type="button" class="pp-primary pp-browse" (click)="$event.stopPropagation(); fileInput.click()">Browse Files</button>
      <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" hidden>
    </div>
    <div class="pp-errors" *ngIf="validationErrors.length || validationWarnings.length" style="margin-top:10px;">
      <div *ngFor="let e of validationErrors" style="color:#e53935; font-size:12px; margin:2px 0;">• {{e}}</div>
      <div *ngFor="let w of validationWarnings" style="color:#607d8b; font-size:12px; margin:2px 0;">• {{w}}</div>
    </div>
    <div class="pp-meta" style="margin-top:10px;display: flex;justify-content: space-around;padding:10px 40px 50px 40px;">
      <div class="pp-meta-item"><mat-icon>image</mat-icon> JPG, PNG, GIF</div>
      <span class="pp-dot">•</span>
      <div class="pp-meta-item"><mat-icon>inventory_2</mat-icon> Max 5MB</div>
    </div>
  </div>
  <div class="pp-footer">
    <button class="pp-danger" (click)="removePhoto()"><mat-icon>delete</mat-icon> Remove Photo</button>
    <div class="pp-actions">
      <button class="pp-secondary" (click)="closeAllPopups()">Cancel</button>
    </div>
  </div>
 </div>

<!-- Adjust Photo Popup -->
<div class="pp-backdrop" *ngIf="showAdjustPopup" (click)="closeAllPopups()"></div>
<div class="pp-modal" *ngIf="showAdjustPopup" (click)="$event.stopPropagation()">
  <div class="pp-header--teal">
    <div class="pp-head-left">
      <div class="pp-head-icon"><mat-icon>photo_camera</mat-icon></div>
      <div>
        <div class="pp-title">Adjust Your Photo</div>
        <div class="pp-subtitle">Position and resize as needed</div>
      </div>
    </div>
    <button class="pp-close" (click)="closeAllPopups()" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>
  <div class="pp-body">
    <div class="pp-adjust">
      <div class="pp-cropper-square" (mousedown)="startDrag($event)" (mousemove)="onDrag($event)" (mouseup)="endDrag()" (mouseleave)="endDrag()" (wheel)="onWheel($event)">
        <img [src]="uploadedImageSrc" [style.transform]="'translate(-50%,-50%) translate(' + translateX + 'px,' + translateY + 'px) scale(' + zoom + ')'" />
        <!-- Circular guide to indicate final visible area -->
        <div class="pp-circle-ring" aria-hidden="true"></div>
        <span class="pp-corner tl"></span>
        <span class="pp-corner tr"></span>
        <span class="pp-corner bl"></span>
        <span class="pp-corner br"></span>
      </div>
      <div class="pp-ctl-row">
        <button type="button" class="pp-ctl-btn" (click)="zoomOut()"><mat-icon>zoom_out</mat-icon></button>
        <input class="pp-ctl-range" type="range" [min]="minZoomToFill()" [max]="zoomMax" step="0.01" [value]="zoom" (input)="onZoomChange($event)" />
        <button type="button" class="pp-ctl-btn" (click)="zoomIn()"><mat-icon>zoom_in</mat-icon></button>
        <button type="button" class="pp-ctl-btn" (click)="resetAdjust()"><mat-icon>restart_alt</mat-icon></button>
      </div>
      <div class="pp-hint text-center">Drag to reposition • Scroll to zoom</div>
    </div>
  </div>
  <div class="pp-footer">
    <div class="pp-actions">
      <button class="pp-secondary pp-back" (click)="backToUpload()"><mat-icon>arrow_back</mat-icon> Back</button>
    </div>
    <div class="pp-actions">
      <button class="pp-primary pp-save" (click)="savePhotoFinal()"><mat-icon>check</mat-icon> Save Photo</button>
    </div>
  </div>
 </div>

<!-- Success Popup -->
<div class="pp-backdrop" *ngIf="showSuccessPopup" (click)="closeAllPopups()"></div>
<div class="pp-modal" *ngIf="showSuccessPopup" (click)="$event.stopPropagation()">
  <div class="pp-success card">
    <div class="pp-success-hero">
      <div class="pp-avatar-lg">
        <ng-container *ngIf="currentPhotoSrc; else initials">
          <img [src]="currentPhotoSrc" alt="updated avatar" />
        </ng-container>
        <ng-template #initials>{{ userInitials }}</ng-template>
      </div>
      <span class="pp-success-badge"><mat-icon>check</mat-icon></span>
    </div>
    <div class="pp-success-title">Photo Updated!</div>
    <div class="pp-success-note">Your company profile picture has been successfully updated.</div>
    <button class="pp-primary pp-done" (click)="closeAllPopups()" style="margin-top: 15px;">Done</button>
  </div>
</div>

